import { render, staticRenderFns } from "./PValue.vue?vue&type=template&id=3fa70b6a&scoped=true"
import script from "./PValue.vue?vue&type=script&lang=js"
export * from "./PValue.vue?vue&type=script&lang=js"
import style0 from "./PValue.vue?vue&type=style&index=0&id=3fa70b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa70b6a",
  null
  
)

export default component.exports